import { TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";
import { CommonState, CommonDispatch } from "../store";

export const useCommonDispatch: () => CommonDispatch = useDispatch;
export const useCommonSelector: TypedUseSelectorHook<CommonState> = useSelector;
